const homeIndex = () => import('../views/home/index')
//底部导航
const Index = () => import('../views/tabBar/index')
//我的申请
const myApply = () => import('../views/tabBar/myApply')

const myPreservation = () => import('../views/tabBar/myPreservation/index.vue')

const myGuarantee = () => import('../views/tabBar/myGuarantee')

//我的复议申请
const myReconsider = () => import('../views/tabBar/myReconsider')
//我的解保申请
const myRelievPreservation = () => import('../views/tabBar/myRelievPreservation')
//我的续保申请
const myContinuationPreservation = () => import('../views/tabBar/myContinuationPreservation')

const personCenter = () => import('../views/tabBar/personCenter')

//选择法院
const selectCourt = () => import('../components/common/selectCourt')
//选择案由
const selectAy = () => import('../components/common/selectAy')
//选择行为
const selectAyXW = () => import('../components/common/selectAyXW')
//个人中心修改
const editUserPassword = () => import('../views/tabBar/editUserPassword')
//个人中心修改密码
const editPersonCenter = () => import('../views/tabBar/editPersonCenter')
//个人中心查看用户详情
const seeUserDetails = () => import('../views/tabBar/personDetails')


export default [
    {
        path: '/home',
        name: 'home',
        component: homeIndex,
        redirect: '/home/index',
        meta: {
            title: '网上保全',
            requireAuth: false,
            keepAlive: false
        },
        children: [
            {
                path: 'Index',
                meta: {
                    title: '首页',
                },
                name: "Index",
                component: Index
            },
            {
                path:'myApply',
                meta: {
                    title: '在线保全-我的申请',
                },
                name: "myApply",
                component: myApply
            },
            {
                path: 'myPreservation',
                meta: {
                    title: '在线保全-保全申请',
                },
                name: "myPreservation",
                component: myPreservation
            },
            {
                path: 'myGuarantee',
                meta: {
                    title: '在线保全-担保申请',
                },
                name: "myGuarantee",
                component: myGuarantee
            },
            {
                path:'myReconsider',
                meta: {
                    title: '在线保全-复议申请',
                },
                name: "myReconsider",
                component: myReconsider
            },
            {
                path:'myRelievPreservation',
                meta: {
                    title: '在线保全-解保申请',
                },
                name: "myRelievPreservation",
                component: myRelievPreservation
            },
            {
                path:'myContinuationPreservation',
                meta: {
                    title: '在线保全-续保申请',
                },
                name: "myContinuationPreservation",
                component: myContinuationPreservation
            },
            {
                path: 'personCenter',
                meta: {
                    title: '在线保全-个人中心',
                },
                name: "personCenter",
                component: personCenter
            },
            {
                path: '/editPersonCenter',
                meta: {
                    title: '在线保全-个人中心修改',
                },
                component: editPersonCenter
            },
            {
                path: '/editUserPassword',
                meta: {
                    title: '在线保全-修改密码',
                },
                component: editUserPassword
            },
            {
                path: '/seeUserDetails',
                meta: {
                    title: '在线保全-用户详情',
                },
                component: seeUserDetails
            }
        ]
    },
    {
        path: '/selectCourt',
        name: 'selectCourt',
        component: selectCourt,
        meta: {
            title: '在线保全-请选择法院',
        },
    },
    {
        path: '/selectAy',
        name: 'selectAy',
        component: selectAy,
        meta: {
            title: '在线保全-请选择案由',
            keepAlive: true // 需要被缓存
        },
    },
    {
        path: '/selectAyXW',
        name: 'selectAyXW',
        component: selectAyXW,
        meta: {
            title: '在线保全-请选择案由',
            keepAlive: true // 需要被缓存
        },
    }
]
